import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import domainStyle from "assets/jss/material-kit-pro-react/views/landingPageSections/domainStyle.jsx";

class AboutTenSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <h5 className={classes.description}>
              At Navitas we encourage our teachers to transform the student
              learning experience by building a range of capabilities, embracing
              learning and teaching challenges, and being responsive to changes
              in the education environment.
            </h5>
            <h5 className={classes.description}>
              To support staff in the development of their skills to bring about
              this transformation, Learning and Teaching Services has launched
              Teaching Excellence at Navitas (TEN): a strategic and innovative
              approach to the delivery and management of academic staff’s
              professional development at Navitas.
            </h5>
            <h5 className={classes.description}>
              myTEN is your learning hub for Teaching Excellence at Navitas:
              self-assess your professional skills, enrol in and explore a range
              of professional development (PD) offerings and access your current
              PD modules.
            </h5>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(domainStyle)(AboutTenSection);
